<template>
  <div v-if="visible" class="popup-box">
    <dialog-drag
      id="message_dialog"
      class="popup"
      :pinned="false"
      :options="dialogOptions"
      :style="currentStyle"
      @drag-end='dialogDragEnd'
    >
      <iframe id="popupId" :src="iframeUrl" frameborder="0" scrolling="auto"></iframe>
    </dialog-drag>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { getNumber } from '@/api/popup.js'
import ReconnectingWebSocket from './reconnecting-websocket.js'
import DialogDrag from 'vue-dialog-drag'
import 'vue-dialog-drag/dist/vue-dialog-drag.css'
export default {
  name: 'Popup',
  components: {
    DialogDrag
  },
  data () {
    return {
      dialogOptions: {
        centered: 'viewport',
        buttonPin: false,
        buttonClose: false,
        width: 1000,
        height: 640
      },
      currentStyle: {},
      visible: false,
      /**
       * iframe的链接：
       * 本地： http://10.1.0.82:8080
       * development: http://dev1.qiaoc.com/information/
       * test: https://test1.qiaoc.com/information/
       *       https://test2.qiaoc.com/information/
       * pre: https://pre.qiaoc.com/information/
       * production: https://www.qiaoc.com/information/
       */
      iframeUrl: `${window.location.origin}/information/`
    }
  },
  computed: {
    ...mapGetters(['nickname', 'avatar'])
  },
  mounted () {
    let url = null
    let timer = null
    let host = window.location.host
    if (host.startsWith('weihaiqiaocai')) {
      host = 'www.' + host
    }
    url = `wss://${host}/finsaas-ump/websocket/server?token=${this.$cookie.get('UCS-AUTHEN-TOKEN')}`
    const socket = new ReconnectingWebSocket(url)
    socket.onopen = () => {
      // heartCheck.start()
    }
    // 从服务端收到信息触发onmessage回调
    socket.onmessage = ({ data, type }) => {
      if (type === 'message' && /^{.+}$/.test(data)) {
        data = JSON.parse(data)
        if (['USER_FILE_TASK', 'USER_FILE_TASK_START'].includes(data.code)) {
          // 任务开始，弹出右下角弹窗
          this.$store.commit('setimportTipsVisible', true)
          if (data.value && /^\[.+\]$/.test(data.value)) {
            this.$store.commit('setUserFileTask', JSON.parse(data.value))
          } else {
            this.$store.commit('setUserFileTask', [])
          }
        } else if (data.code === 'ONE_TOUCH_RESULT') {
          this.$store.commit('setStatementTipsVisible', true)
          if (data.value && /^\{.+\}$/.test(data.value)) {
            this.$store.commit('setStatementExecuteResult', JSON.parse(data.value))
          } else {
            this.$store.commit('setStatementExecuteResult', {})
          }
        }
      }
      if (timer) clearTimeout(timer)
      timer = setTimeout(() => {
        this.goMessage()
      }, 600)
    }
    // 连接失败触发onerror回调
    socket.onerror = () => {
      // reconnect()
    }
    // 调用关闭连接，状态立刻变成2(正在关闭)。关闭成功触发onclose变成3
    // socket.close()
    // 连接关闭触发onclose回调，有回调参数
    socket.onclose = () => {
      console.log('456')
      // reconnect()
    }
    // 第一次获取未读信息条数
    this.$nextTick(() => {
      this.goMessage()
    })
    window.addEventListener('message', (e) => {
      if (e.data.msg === 0) this.visible = false
    }, false)

    window.addEventListener('resize', this.windowSizeChange, false)
  },
  methods: {
    close () {
      this.visible = false
    },
    open () {
      this.visible = !this.visible
      if (this.visible) {
        this.$nextTick(() => {
          this.$store.commit('SET_NUMBER', 0)
          this.goMessage()
        })
      }
    },
    goMessage () {
      if (!this.$cookie.get('UCS-AUTHEN-TOKEN')) return false
      if (!this.visible) {
        const req = {}
        getNumber(req).then(res => {
          if (res.code === '0') {
            this.$store.commit('SET_NUMBER', res.data)
          }
        }).catch(err => {
          this.$notification.error({
            message: '错误',
            description: err.msg || '请求失败，请重试',
            duration: 3
          })
        })
      }
      const iframeNode = document.getElementById('popupId')
      if (iframeNode) {
        const obj = {
          msg: this.$cookie.get('UCS-AUTHEN-TOKEN'),
          name: this.nickname,
          avatar: this.avatar
        }
        iframeNode.contentWindow.postMessage(obj, '*')
        iframeNode.onload = () => {
          iframeNode.contentWindow.postMessage(obj, '*')
        }
      }
    },
    windowSizeChange () {
      const windW = document.body.offsetWidth
      const windH = document.body.offsetHeight
      const { width, height } = this.dialogOptions
      const posX = (windW - width) / 2
      const posY = (windH - height - 40) / 2 // 40是最上面菜单栏的高度
      this.currentStyle = {
        left: `${posX}px`,
        top: `${posY}px`
      }
    },
    dialogDragEnd (obj) {
      const posX = obj.x
      const posY = obj.y
      this.currentStyle = {
        left: `${posX}px`,
        top: `${posY}px`
      }
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.windowSizeChange, false)
  }
}
</script>
<style lang="less">
.popup-box {
  position: fixed;
  top: 40px;
  right: 0;
  bottom: 0;
  left: 0;
  // border: 1px solid red;
}
.popup {
  // position: absolute;
  // top: 20%;
  // left: 30%;
  // margin-top: -320px;
  // margin-left: -500px;
  // width: 1000px;
  // max-width: 40%;
  // height: 640px;
  // max-height: 80%;
  // border: 1px solid red;
  // background: black;
}
.popup-box {
  .dialog-drag {
    border: 1px solid #9FA2A9;
    box-shadow: none;
    .dialog-header {
      cursor: move;
      background: #fff;
      position: absolute;
      right: 125px;
      width: 527px;
      background: transparent;
      height: 56px;
    }
    .dialog-body {
      padding: 0;
      height: 100%;
      width: 100%;
      overflow: hidden;
    }
  }
}
iframe {
  width: 100%;
  height: 100%;
}
</style>
